export interface ContactData {
  title: string
  subtitle: string
  description: string
  form: {
    title: string
    fields: {
      name: {
        label: string
        placeholder: string
        required: boolean
      }
      email: {
        label: string
        placeholder: string
        required: boolean
      }
      company: {
        label: string
        placeholder: string
        required: boolean
      }
      message: {
        label: string
        placeholder: string
        required: boolean
      }
    }
    button: {
      text: string
      loadingText: string
    }
  }
  contactInfo: {
    title: string
    description: string
    details: {
      email: {
        label: string
        value: string
        href: string
      }
      phone: {
        label: string
        value: string
        href: string
      }
      location: {
        label: string
        value: string
      }
    }
  }
  socialLinks: {
    title: string
    links: {
      linkedin: string
      github: string
      x: string
    }
  }
  availability: {
    title: string
    description: string
    status: string
  }
}

export const contactData: ContactData = {
  title: "Let's",
  subtitle: "Connect",
  description: "Ready to discuss your project needs? Whether you're looking to build a new application, optimize existing systems, or implement DevOps solutions, I'm here to help.",
  form: {
    title: "Send a Message",
    fields: {
      name: {
        label: "Name *",
        placeholder: "Your full name",
        required: true
      },
      email: {
        label: "Email *",
        placeholder: "your.email@company.com",
        required: true
      },
      company: {
        label: "Company",
        placeholder: "Your company name",
        required: false
      },
      message: {
        label: "Message *",
        placeholder: "Tell me about your project or development needs...",
        required: true
      }
    },
    button: {
      text: "Send Message",
      loadingText: "Sending..."
    }
  },
  contactInfo: {
    title: "Get in Touch",
    description: "I'm always interested in new opportunities and challenging projects. Whether you have a question or just want to say hi, feel free to reach out!",
    details: {
      email: {
        label: "Email",
        value: "adebayoh9@gmail.com",
        href: "mailto:adebayoh9@gmail.com"
      },
      phone: {
        label: "Phone",
        value: "+234 (916) 152-0285",
        href: "tel:+2349161520285"
      },
      location: {
        label: "Location",
        value: "Available for Remote & Hybrid"
      }
    }
  },
  socialLinks: {
    title: "Follow Me",
    links: {
      github: "https://github.com/Huangdi-599",
      linkedin: "https://www.linkedin.com/in/me-huangdi/",
      x: "https://x.com/me_huangdi"
    }
  },
  availability: {
    title: "Current Availability",
    description: "I'm currently available for new opportunities and consulting projects.",
    status: "Available for new projects and full-time , contract roles"
  }
} 